import React, { useState, useEffect } from "react";
import { SketchPicker } from "react-color";

function ColourPIcker({
  original_chart,
  index,
  default_color,
  setsample_chart,
}) {
  const [color, setcolor] = useState(default_color);

  useEffect(() => {
    setcolor(default_color);
  }, [default_color]);

  const onSwatchHover_RGBA = (color, key) => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    original_chart.data.datasets[0].backgroundColor[index] = rgba;
    console.log(rgba);
    original_chart.update();
    setcolor(rgba);
    setsample_chart((prev) => {
      return {
        ...prev,
        data: {
          ...prev.data,
          datasets: prev.data.datasets.map((dataset, idx) =>
            idx === 0
              ? {
                  ...dataset,
                  backgroundColor: dataset.backgroundColor.map((color, i) =>
                    i === index ? rgba : color
                  ),
                }
              : dataset
          ),
        },
      };
    });
  };

  const [display_RGBA, setdisplay_RGBA] = useState(false);

  function handleRGBA() {
    setdisplay_RGBA(!display_RGBA);
  }
  return (
    <>
      <div className="nano-colorpicker" onClick={handleRGBA}>
        <i
          style={{
            height: "28px",
            width: "28px",
            background: color,
            display: "block",
          }}
        />
      </div>

      {display_RGBA ? (
        <SketchPicker
          color={color}
          width="160px"
          onChangeComplete={(color_) => {
            onSwatchHover_RGBA(color_, index);
          }}
        />
      ) : null}
    </>
  );
}

export default ColourPIcker;
